
const shippingCosts = JSON.parse(process.env.GATSBY_SHIPPING_COSTS);

export const calculateShippingPrice = (subtotal) => {
    if (subtotal < shippingCosts.minOrderValue) {
        return shippingCosts.shippingValue;
    }
    return 0;
  };